import { yupResolver } from '@hookform/resolvers/yup';
import { TParametersDataTableData } from '@Modules/admin/basicSettings/containers/formHandlers/center/update/parameters/ParametersDataTableMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TFormUIProps } from '@Modules/core/types/FormUIPropsType';
import displayCustomInputs from '@Shared/utils/displayCustomInputs';
import React from 'react';
import { useForm } from 'react-hook-form';

import { IParamDataTableRowFormMeta } from '@Modules/admin/basicSettings/containers/formHandlers/center/update/parameters/parametersDataTableRowMeta';
import { IParametersFormMeta } from '@Modules/admin/basicSettings/containers/formHandlers/center/update/parameters/ParametersMeta';
type Props = {
    meta: IParamDataTableRowFormMeta,
    data: TParametersDataTableData
} & TFormUIProps;

export default React.forwardRef(function ParametersTableFormUI ({ onSubmit, isLoading, isSubmitting, meta, data }: Props, ref: any) {

  const submitBtnRef = React.useRef<HTMLButtonElement>(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ 
    defaultValues: data,
    resolver: yupResolver(meta.schema) 
  });

  React.useImperativeHandle(ref, () => ({
    submitBtnRef
  }));

  console.log("================= Parameters Table Form errors =================");
  console.log(errors);
  console.log("================= END =================");

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)} ref={ref}>
        
      <CC.SimpleGrid columns={{base: 1, md: 3}} spacing={10} my={10}>
        {displayCustomInputs<IParametersFormMeta>(meta, register, errors, isLoading, [meta.tva1.name, meta.tva2.name])}
      </CC.SimpleGrid>

      <CC.SimpleGrid columns={{base: 1, md: 3}} spacing={10} my={10}>
        {displayCustomInputs<IParametersFormMeta>(meta, register, errors, isLoading, [meta.hpx.name, meta.bank.name])}
      </CC.SimpleGrid>

      {/* <CC.Stack>
        {displayCustomTextareas<IMemoFormMeta>(meta, register, errors, isLoading, [meta.memo.name])}
      </CC.Stack> */}
      
      <button type={'submit'} ref={submitBtnRef} style={{display: "none"}}>
        Enregistrer
      </button>
    </CC.Box>
  );
});

// export default ParametersFormUI;
